import React, { useState, useCallback } from 'react';
import { BootScreen } from '@/components/desktop/BootScreen';
import { Desktop } from '@/components/desktop/Desktop';

function App() {
  const [isBooted, setIsBooted] = useState(false);

  const handleBootComplete = useCallback(() => {
    setIsBooted(true);
  }, []);

  return (
    <div className="App">
      {!isBooted && <BootScreen onBootComplete={handleBootComplete} />}
      {isBooted && <Desktop />}
    </div>
  );
}

export default App;
